import { type ReactNode } from "react";
import { Tabs, type Tab } from "shared/components/BaseTabs";
import { Show } from "shared/components";
import type { ComposerTab } from "./constants";

interface ComposerFooterRowProps {
  tabs: Tab<ComposerTab>[];
  active: ComposerTab;
  onTabChange: (tab: ComposerTab) => void;
  showTabs?: boolean;
  leftExtra?: ReactNode;
  children?: ReactNode;
}

export const ComposerFooterRow = ({
  tabs,
  active,
  onTabChange,
  showTabs = true,
  leftExtra,
  children
}: ComposerFooterRowProps) => (
  <div className="px-6 py-4 min-h-[80px] border-b border-alpha-40 flex flex-col xl:flex-row xl:items-center xl:justify-between gap-4 flex-wrap">
    <Show if={showTabs || !!leftExtra}>
      <div className="flex items-center gap-4">
        <Show if={showTabs}>
          <Tabs
            tabs={tabs}
            active={active}
            onChange={onTabChange}
            tabStyle="ghost-pink"
            size="sm"
            fullWidthTabs={false}
            className="[&_button]:rounded-full"
          />
        </Show>
        {leftExtra}
      </div>
    </Show>
    {children}
  </div>
);
